module.exports = __webpack_public_path__ + "img/no-image.7abc3466.png";